import { Injectable } from '@angular/core';

@Injectable()
export class SessionService {

  constructor() { }

  public getSessionStorage(key: string) {
    return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : null;
  }

  public setSessionStorage(key: string, data: any): void {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  public removeSessionStorage(key: string): void {
    sessionStorage.removeItem(key);
  }


}
